var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10L5 22.1212L11.25 25.8728L17.5 22.1212L21.0294 16.0606L17.5 10Z",
    fill: "#FF2820"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 22.1212H5V37.8788L11.25 41.2069L17.5 37.8788V22.1212Z",
    fill: "#0084FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 37.8788V45.9596C5 48.1818 6.875 50 9.1667 50H17.5L21.0294 43.5661L17.5 37.8788H5Z",
    fill: "#0066DD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4185 14.3037L44.6875 20.2422V20.3031L42.1661 29.6374L44.6875 39.0837L52.3841 45.0904C53.4167 45.9306 55 45.2249 55 43.9141V15.48C55 14.1692 53.4511 13.4634 52.4185 14.3037Z",
    fill: "#00AD3C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6875 20.2421V13.994C44.6875 11.7973 42.8523 10 40.6094 10H17.5V22.1212H32.8125V30L41.0395 29.1113L44.6875 20.2421Z",
    fill: "#FFBA00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8125 37.8788H17.5V50H40.6094C42.8523 50 44.6875 48.2053 44.6875 46.0117V39.0909L40.6062 30.9601L32.8125 30V37.8788Z",
    fill: "#00AD3C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8125 30L44.6875 39.091V20.2422L32.8125 30Z",
    fill: "#00831E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeet);
export default __webpack_public_path__ + "static/media/meet.eefaa8bf1716a771fb23ff5a0058603e.svg";
export { ForwardRef as ReactComponent };